<template>
  <div>
    <div>
      <top-item-com active="8" :ssid="ssid"></top-item-com>
    </div>
    <div></div>
    <van-pull-refresh
      v-model="isLoading"
      @refresh="onRefresh"
      :disabled="!isAtTop || showGroupSheet || showProjectSheet"
    >
      <van-tabs v-model="queryType" @change="toTab" class="custom-tabs">
        <van-tab title="秩序册" :name="'zxc'">
          <template #title>
            <div class="tab-title">
              <van-icon name="notes-o" />
              <span>秩序册</span>
            </div>
          </template>
        </van-tab>
        <van-tab title="成绩册" :name="'cjc'">
          <template #title>
            <div class="tab-title">
              <van-icon name="medal-o" />
              <span>成绩册</span>
            </div>
          </template>
        </van-tab>
        <van-tab title="出线名次" :name="'cxmc'">
          <template #title>
            <div class="tab-title">
              <van-icon name="award-o" />
              <span>出线名次</span>
            </div>
          </template>
        </van-tab>
        <van-tab title="所有名次" :name="'cjpm'">
          <template #title>
            <div class="tab-title">
              <van-icon name="bar-chart-o" />
              <span>所有名次</span>
            </div>
          </template>
        </van-tab>
      </van-tabs>

      <!-- 筛选栏 -->
      <div class="filter-bar">
        <div class="filter-item" @click="showGroupSheet = true">
          <div class="filter-label">
            <van-icon name="cluster-o" />
            <span>组别</span>
          </div>
          <div class="filter-value">
            <span>{{ selectedGroup || "全部" }}</span>
            <van-icon name="arrow-down" />
          </div>
        </div>

        <div class="filter-divider"></div>

        <div class="filter-item" @click="showProjectSheet = true">
          <div class="filter-label">
            <van-icon name="apps-o" />
            <span>项目</span>
          </div>
          <div class="filter-value">
            <span>{{ selectedProject || "全部" }}</span>
            <van-icon name="arrow-down" />
          </div>
        </div>
      </div>

      <!-- 项目列表 -->
      <div class="project-list" v-if="queryType !== 'cxmc'">
        <div
          v-for="(item, index) in filteredResultList"
          :key="index"
          @click="navToUrl(item)"
          class="project-card-wrapper"
        >
          <div class="project-card">
            <!-- 左侧图标 -->
            <div class="card-icon">
              <div class="icon-wrapper">
                <van-icon
                  :name="
                    queryType === 'zxc'
                      ? 'notes-o'
                      : queryType === 'cjc'
                      ? 'medal-o'
                      : 'bar-chart-o'
                  "
                />
              </div>
            </div>

            <!-- 中间内容 -->
            <div class="card-content">
              <div class="project-name">
                <label>{{ item.XMQC }}</label>
                <label
                  style="float: right;color: #666;font-weight:500"
                  v-if="queryType === 'zxc' && item.ISZXC === '1'"
                >
                  {{ item.ZTM }}
                  {{
                    item.SSLX.substr(1, 2) === "S"
                      ? "人"
                      : item.SSLX.substr(1, 2) === "D"
                      ? "对"
                      : item.SSLX.substr(1, 2) === "T"
                      ? "队"
                      : ""
                  }}
                </label>
                <label
                  style="float: right;color: #666;font-weight:500"
                  v-if="
                    (queryType === 'cjc' || queryType === 'cjpm') &&
                      item.ISCJC === '1'
                  "
                >
                  {{ item.ZTM }}
                  {{
                    item.SSLX.substr(1, 2) === "S"
                      ? "人"
                      : item.SSLX.substr(1, 2) === "D"
                      ? "对"
                      : item.SSLX.substr(1, 2) === "T"
                      ? "队"
                      : ""
                  }}
                </label>
              </div>
              <div class="project-info">
                <span class="info-badge">{{ item.XMJC }}</span>
                <span class="info-divider">·</span>
                <span class="info-text">{{ item.SSLXMC }}</span>
              </div>

              <!-- 发布状态 -->
              <div class="publish-status">
                <van-tag
                  :type="
                    (queryType === 'zxc' ? item.ISZXC : item.ISCJC) === '1'
                      ? 'success'
                      : 'warning'
                  "
                  size="medium"
                  round
                >
                  <van-icon
                    :name="
                      (queryType === 'zxc' ? item.ISZXC : item.ISCJC) === '1'
                        ? 'success'
                        : 'clock-o'
                    "
                  />
                  {{
                    (queryType === "zxc" ? item.ISZXC : item.ISCJC) === "1"
                      ? "已发布"
                      : "未发布"
                  }}
                </van-tag>
              </div>
            </div>

            <!-- 右侧箭头 -->
            <div class="card-arrow">
              <van-icon name="arrow" />
            </div>
          </div>
        </div>

        <!-- 空状态 -->
        <div
          v-if="filteredResultList.length === 0 && !isLoading"
          class="empty-state"
        >
          <van-empty image="search" description="暂无数据" />
        </div>
      </div>

      <!-- 组别筛选弹窗 -->
      <van-action-sheet
        v-model="showGroupSheet"
        title="选择组别"
        :actions="groupActions"
        @select="onSelectGroup"
        cancel-text="取消"
        close-on-click-action
      />

      <!-- 项目筛选弹窗 -->
      <van-action-sheet
        v-model="showProjectSheet"
        title="选择项目"
        :actions="projectActions"
        @select="onSelectProject"
        cancel-text="取消"
        close-on-click-action
      />

      <!-- 出线名次 开始 -->
      <div v-if="queryType === 'cxmc'" class="cxmc-container">
        <!-- 搜索框 -->
        <div class="search-bar">
          <van-search
            v-model="searchKeyword"
            placeholder="搜索选手姓名或队伍"
            show-action
            @search="onSearch"
          >
            <template #action>
              <div @click="onSearch" class="search-button">搜索</div>
            </template>
          </van-search>
        </div>

        <!-- 空状态 -->
        <div v-if="cxMcList.length === 0 && !isLoading" class="empty-state">
          <van-empty image="search" description="暂无出线名次数据" />
        </div>

        <div
          v-for="(mainItem, mainIndex) in cxMcList"
          :key="mainIndex"
          class="cxmc-section"
          :ref="'section-' + mainIndex"
        >
          <div v-if="mainItem.length > 0" class="cxmc-card">
            <!-- 项目标题 -->
            <div class="cxmc-header">
              <div class="header-icon">🏆</div>
              <div class="header-content">
                <h4 class="project-title">{{ mainItem[0].XMQC }}</h4>
                <p class="project-subtitle">共 {{ mainItem.length }} 名选手</p>
              </div>
              <div class="header-badge">
                <van-icon name="medal-o" />
              </div>
            </div>

            <!-- 出线名次表格 -->
            <div class="cxmc-table-wrapper">
              <table class="cxmc-table">
                <thead>
                  <tr>
                    <th class="rank-col">
                      <div class="th-content">
                        <van-icon name="award-o" />
                        <span>名次</span>
                      </div>
                    </th>
                    <th class="team-col">
                      <div class="th-content">
                        <van-icon name="friends-o" />
                        <span>队伍全称</span>
                      </div>
                    </th>
                    <th class="player-col">
                      <div class="th-content">
                        <van-icon name="user-o" />
                        <span>人/队名</span>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in mainItem"
                    :key="index"
                    :ref="'row-' + mainIndex + '-' + index"
                    :class="[
                      'table-row',
                      {
                        'quit-row': item.ISPF === '1' || item.ISPF === '2'
                      },
                      { 'even-row': index % 2 === 1 },
                      { 'highlight-row': isHighlighted(mainIndex, index) }
                    ]"
                  >
                    <td class="rank-cell">
                      <div
                        class="rank-badge"
                        :class="getRankClass(item.MCDATA)"
                      >
                        <span class="rank-icon">{{
                          getRankIcon(item.MCDATA)
                        }}</span>
                        <span class="rank-number">{{ item.MCDATA }}</span>
                      </div>
                    </td>
                    <td class="team-cell">
                      <div class="team-info">
                        <van-icon name="flag-o" class="team-icon" />
                        <span>{{ item.DWQC1 }}</span>
                      </div>
                    </td>
                    <td class="player-cell">
                      <div class="player-info">
                        <span class="player-name">{{ item.RYXM1 }}</span>
                        <span
                          v-if="item.RYXM2.length > 0"
                          class="player-divider"
                          >/</span
                        >
                        <span v-if="item.RYXM2.length > 0" class="player-name">
                          {{ item.RYXM2 }}
                        </span>
                        <span
                          v-if="item.RYXM_FIN.length > 0"
                          class="player-divider"
                        >
                          /
                        </span>
                        <span
                          v-if="item.RYXM_FIN.length > 0"
                          class="player-name"
                        >
                          {{ item.RYXM_FIN }}
                        </span>
                        <span
                          v-if="item.ISPF === '1' || item.ISPF === '2'"
                          class="quit-tag"
                        >
                          <van-icon name="warning-o" />
                          弃权
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div style="width:5px;height:150px;"></div>
    </van-pull-refresh>
    <loading-com />
    <!-- 返回顶部按钮 -->
    <back-to-top-com />
  </div>
</template>

<script>
import HeaderCom from "./../commonCom/HeaderCom.vue";
import LoadingCom from "../commonCom/LoadingCom.vue";
import BackToTopCom from "../commonCom/BackToTopCom.vue";
import TopItemCom from "../commonCom/TopItemCom.vue";
export default {
  components: { HeaderCom, LoadingCom, BackToTopCom, TopItemCom },
  name: "ChangeXmIndex",

  data() {
    return {
      isLoading: false,
      ssid: "",
      resultList: [],
      queryType: "",
      routeValue: "",
      cxMcList: [],
      isAtTop: true, // 是否在顶部
      // 筛选相关
      showGroupSheet: false, // 显示组别选择
      showProjectSheet: false, // 显示项目选择
      selectedGroup: "", // 选中的组别
      selectedProject: "", // 选中的项目
      groupList: [], // 组别列表
      projectList: [], // 项目列表
      // 搜索相关
      searchKeyword: "", // 搜索关键词
      highlightedRow: null // 高亮的行 {mainIndex, index}
    };
  },
  computed: {
    // 组别选项
    groupActions() {
      const actions = [{ name: "全部", value: "" }];
      this.groupList.forEach(group => {
        actions.push({ name: group, value: group });
      });
      return actions;
    },
    // 项目选项
    projectActions() {
      const actions = [{ name: "全部", value: "" }];
      this.projectList.forEach(project => {
        actions.push({ name: project, value: project });
      });
      return actions;
    },
    // 过滤后的结果列表
    filteredResultList() {
      let list = this.resultList;

      // 按组别筛选（使用 XMJC 字段）
      if (this.selectedGroup) {
        list = list.filter(item => item.XMJC === this.selectedGroup);
      }

      // 按项目筛选（使用 SSLXMC 字段）
      if (this.selectedProject) {
        list = list.filter(item => item.SSLXMC === this.selectedProject);
      }

      // 按项目编号（XMBH）升序排序
      return list.sort((a, b) => {
        const xmbhA = a.XMBH || "";
        const xmbhB = b.XMBH || "";
        // 如果是数字，按数字排序；否则按字符串排序
        const numA = parseInt(xmbhA);
        const numB = parseInt(xmbhB);
        if (!isNaN(numA) && !isNaN(numB)) {
          return numA - numB;
        }
        return xmbhA.toString().localeCompare(xmbhB.toString(), "zh-CN");
      });
    }
  },
  created() {
    this.utilPost = this.$util.handler;
    this.ssid = this.$route.query.ssid;
    this.queryType = "zxc";
  },
  mounted() {
    var tempType = window.localStorage.getItem("cdQueryType");
    if (tempType === undefined || tempType === null) {
      window.localStorage.setItem("cdQueryType", this.queryType);
    } else {
      this.queryType = tempType;
    }
    var routeValue = localStorage.getItem("routeValue");
    this.routeValue = routeValue;
    var openIdEn = localStorage.getItem("openIdEn");
    if (openIdEn === undefined || openIdEn === null || openIdEn.length === 0) {
      this.utilPost.getOpenId(function(openId) {});
    }
    this.resultList = [];
    //必须等界面渲染完成后 在加载
    // this.mainLoadData();
    this.toTab();
    // 监听滚动事件
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    // 移除滚动监听
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    // 处理滚动事件
    handleScroll() {
      // 判断是否在顶部（允许10px的误差）
      this.isAtTop =
        window.pageYOffset <= 10 || document.documentElement.scrollTop <= 10;
    },
    // 获取名次样式类
    getRankClass(rank) {
      const rankNum = parseInt(rank);
      if (rankNum === 1) return "rank-gold";
      if (rankNum === 2) return "rank-silver";
      if (rankNum === 3) return "rank-bronze";
      return "rank-normal";
    },
    // 获取名次图标
    getRankIcon(rank) {
      const rankNum = parseInt(rank);
      if (rankNum === 1) return "🥇";
      if (rankNum === 2) return "🥈";
      if (rankNum === 3) return "🥉";
      return "🏅";
    },
    // 获取前三名数量
    getTopThreeCount(list) {
      if (!list || list.length === 0) return 0;
      return list.filter(item => {
        const rank = parseInt(item.MCDATA);
        return rank >= 1 && rank <= 3;
      }).length;
    },
    // 选择组别
    onSelectGroup(action) {
      this.selectedGroup = action.value;
      this.showGroupSheet = false;
    },
    // 选择项目
    onSelectProject(action) {
      this.selectedProject = action.value;
      this.showProjectSheet = false;
    },
    // 重置筛选
    resetFilters() {
      this.selectedGroup = "";
      this.selectedProject = "";
    },
    // 判断是否高亮
    isHighlighted(mainIndex, index) {
      return (
        this.highlightedRow &&
        this.highlightedRow.mainIndex === mainIndex &&
        this.highlightedRow.index === index
      );
    },
    // 搜索功能
    onSearch() {
      if (!this.searchKeyword || this.searchKeyword.trim() === "") {
        this.$toast("请输入搜索关键词");
        return;
      }

      const keyword = this.searchKeyword.trim().toLowerCase();
      let found = false;

      // 遍历所有数据查找匹配项
      for (let mainIndex = 0; mainIndex < this.cxMcList.length; mainIndex++) {
        const mainItem = this.cxMcList[mainIndex];
        for (let index = 0; index < mainItem.length; index++) {
          const item = mainItem[index];
          const ryxm1 = (item.RYXM1 || "").toLowerCase();
          const ryxm2 = (item.RYXM2 || "").toLowerCase();
          const dwqc1 = (item.DWQC1 || "").toLowerCase();

          // 检查是否匹配选手姓名或队伍名称
          if (
            ryxm1.includes(keyword) ||
            ryxm2.includes(keyword) ||
            dwqc1.includes(keyword)
          ) {
            found = true;
            // 设置高亮
            this.highlightedRow = { mainIndex, index };

            // 滚动到目标位置
            this.$nextTick(() => {
              const refName = "row-" + mainIndex + "-" + index;
              const targetRow = this.$refs[refName];
              if (targetRow && targetRow[0]) {
                targetRow[0].scrollIntoView({
                  behavior: "smooth",
                  block: "center"
                });

                // 3秒后取消高亮
                setTimeout(() => {
                  this.highlightedRow = null;
                }, 3000);
              }
            });
            return;
          }
        }
      }

      // 未找到匹配项
      if (!found) {
        this.$toast("未找到匹配的选手或队伍");
        this.highlightedRow = null;
      }
    },
    // 提取组别和项目列表
    extractFilters() {
      // 提取唯一的组别
      const groups = new Set();
      // 提取唯一的项目
      const projects = new Set();

      this.resultList.forEach(item => {
        if (item.XMJC) {
          groups.add(item.XMJC);
        }
        if (item.SSLXMC) {
          projects.add(item.SSLXMC);
        }
      });

      this.groupList = Array.from(groups).sort();
      this.projectList = Array.from(projects).sort();
    },
    onRefresh() {
      this.toTab();
    },
    toTab() {
      window.localStorage.setItem("cdQueryType", this.queryType);
      if (this.queryType === "cxmc") {
        this.getCxmc();
      } else {
        this.mainLoadData();
      }
    },
    getCxmc() {
      var busData = {};
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: "wapGL", //反射名称
          methodName: "getCxmc" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      //alert(JSON.stringify(paramData));
      this.utilPost.sendPost().then(data => {
        this.isLoading = false;
        this.cxMcList = data.content;
      });
    },
    onTopClickLeft() {
      this.$router.push({ path: "/xmIndex", query: { ssid: this.ssid } });
    },
    mainLoadData() {
      var busData = {};
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: "wapGL", //反射名称
          methodName: "getAllXmData" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      //alert(JSON.stringify(paramData));
      this.utilPost.sendPost().then(data => {
        this.isLoading = false;
        //alert(JSON.stringify(data));
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }
        this.resultList = data.content;
        // 提取筛选选项
        this.extractFilters();
      });
    },
    navToUrl(item) {
      if (this.queryType === "zxc") {
        if (item.ISZXC !== "1") {
          alert("未发布秩序册");
          return;
        }
        this.$router.push({
          path: "/zxcIndex",
          query: { ssid: this.ssid, xmid: item.XMID, sszl: item.SSZL }
        });
      } else if (this.queryType === "cjc") {
        if (this.queryType === "cjc") {
          if (item.ISCJC !== "1") {
            alert("未发布成绩册");
            return;
          }
          this.$router.push({
            path: "/cjcIndex",
            query: { ssid: this.ssid, xmid: item.XMID, sszl: item.SSZL }
          });
        }
      } else if (this.queryType === "cjpm") {
        if (this.queryType === "cjpm") {
          if (item.ISCJC !== "1") {
            alert("未发布");
            return;
          }
          this.$router.push({
            path: "/cjpmIndex",
            query: { ssid: this.ssid, xmid: item.XMID, sszl: item.SSZL }
          });
        }
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
/* ==================== 基础样式 ==================== */
.van-field {
  padding: 3px;
  border-radius: 5px;
}

.dropClass {
  background: #ffffff4f;
  padding: 8px;
  border-radius: 5px;
  font-size: 13px;
  color: #fff;
}

.van-overlay {
  background-color: rgba(0, 0, 0, 0.5);
}

.itemContentMain {
  background: #fff;
  margin: 10px;
  padding: 10px;
  border-radius: 5px;
  position: relative;
}

.van-image--round {
  margin-top: 15px;
}

.textMainDiv {
  padding-top: 15px;
}

/deep/.van-nav-bar {
  position: fixed;
  top: 0px;
  width: 100%;
}

/* ==================== 筛选栏样式 ==================== */
.filter-bar {
  display: flex;
  align-items: center;
  background: #fff;
  padding: 12px 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  position: sticky;
  top: 50px;
  z-index: 99;
  gap: 12px;
}

.filter-item {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-radius: 12px;
  border: 1px solid #e9ecef;
  cursor: pointer;
  transition: all 0.3s ease;

  &:active {
    transform: scale(0.98);
    background: linear-gradient(135deg, #e8f2ff 0%, #f0f7ff 100%);
    border-color: #185f9b;
  }
}

.filter-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #666;
  font-weight: 500;

  .van-icon {
    font-size: 16px;
    color: #185f9b;
  }
}

.filter-value {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #333;
  font-weight: 500;

  span {
    max-width: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .van-icon {
    font-size: 14px;
    color: #999;
    transition: transform 0.3s ease;
  }
}

.filter-item:active .filter-value .van-icon {
  transform: rotate(180deg);
}

.filter-divider {
  width: 1px;
  height: 24px;
  background: #e9ecef;
}

.filter-reset {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #ff4d4f 0%, #ff7875 100%);
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(255, 77, 79, 0.3);

  .van-icon {
    font-size: 18px;
    color: #fff;
  }

  &:active {
    transform: scale(0.9) rotate(180deg);
  }
}

/* 筛选弹窗样式 */
/deep/ .van-action-sheet {
  max-height: 70vh;
  border-radius: 16px 16px 0 0;
}

/deep/ .van-action-sheet__header {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
}

/deep/ .van-action-sheet__item {
  padding: 14px 16px;
  font-size: 15px;
  color: #333;
  transition: all 0.2s ease;

  &:active {
    background: linear-gradient(135deg, #e8f2ff 0%, #f0f7ff 100%);
  }
}

/deep/ .van-action-sheet__cancel {
  padding: 14px 16px;
  font-size: 15px;
  font-weight: 500;
  color: #666;
}

/* ==================== Tab 样式美化 ==================== */
.custom-tabs {
  background: #fff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);

  /deep/ .van-tabs__wrap {
    height: 50px;
  }

  /deep/ .van-tabs__nav {
    background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  }

  /deep/ .van-tab {
    font-size: 15px;
    font-weight: 500;
    color: #666;
    transition: all 0.3s ease;
  }

  /deep/ .van-tab--active {
    color: #185f9b;
    font-weight: 600;
  }

  /deep/ .van-tabs__line {
    background: linear-gradient(90deg, #185f9b 0%, #1a6ba8 100%);
    height: 3px;
    border-radius: 3px;
  }
}

.tab-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;

  .van-icon {
    font-size: 20px;
  }

  span {
    font-size: 13px;
  }
}

/* ==================== 项目列表样式 ==================== */
.project-list {
  padding: 12px;
  background: #f5f7fa;
  min-height: calc(100vh - 210px);
}

.project-card-wrapper {
  margin-bottom: 12px;
  animation: fadeInUp 0.4s ease;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.project-card {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
    background: linear-gradient(180deg, #185f9b 0%, #1a6ba8 100%);
    transition: width 0.3s ease;
  }

  &:hover {
    transform: translateX(4px);
    box-shadow: 0 4px 20px rgba(24, 95, 155, 0.15);

    &::before {
      width: 6px;
    }

    .card-arrow {
      transform: translateX(4px);
    }
  }

  &:active {
    transform: translateX(2px) scale(0.98);
  }
}

/* 左侧图标 */
.card-icon {
  flex-shrink: 0;
  margin-right: 14px;

  .icon-wrapper {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 12px rgba(24, 95, 155, 0.25);

    .van-icon {
      font-size: 24px;
      color: #fff;
    }
  }
}

/* 中间内容 */
.card-content {
  flex: 1;
  min-width: 0;
}

.project-name {
  font-size: 16px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 8px;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.project-info {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  font-size: 13px;
  color: #666;

  .info-badge {
    display: inline-block;
    padding: 2px 10px;
    background: linear-gradient(135deg, #e8f2ff 0%, #d4e7ff 100%);
    color: #185f9b;
    border-radius: 12px;
    font-weight: 500;
    font-size: 12px;
  }

  .info-divider {
    color: #ddd;
  }

  .info-text {
    color: #666;
  }
}

.publish-status {
  .van-tag {
    padding: 4px 12px;
    font-size: 12px;
    font-weight: 500;

    .van-icon {
      margin-right: 4px;
      font-size: 14px;
    }
  }
}

/* 右侧箭头 */
.card-arrow {
  flex-shrink: 0;
  margin-left: 12px;
  transition: transform 0.3s ease;

  .van-icon {
    font-size: 18px;
    color: #c0c4cc;
  }
}

/* 空状态 */
.empty-state {
  padding: 60px 20px;
  text-align: center;

  /deep/ .van-empty__image {
    width: 120px;
    height: 120px;
  }

  /deep/ .van-empty__description {
    font-size: 14px;
    color: #999;
    margin-top: 16px;
  }
}

/* ==================== 出线名次样式 ==================== */
.cxmc-container {
  margin-top: 0;
  padding: 12px;
  background: #f5f7fa;
  min-height: calc(100vh - 210px);
}

/* 搜索栏样式 */
.search-bar {
  margin-top: 6px;
  margin-bottom: 12px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  overflow: hidden;

  /deep/ .van-search {
    padding: 0px;
  }

  /deep/ .van-search__content {
    background: #fff;
    border-radius: 12px;
    padding-left: 12px;
  }

  /deep/ .van-field__left-icon {
    color: #185f9b;
  }

  /deep/ .van-cell {
    padding: 8px 0;
  }
}

.search-button {
  padding: 0px 16px;
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
  color: #fff;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(24, 95, 155, 0.3);

  &:active {
    transform: scale(0.95);
    box-shadow: 0 1px 4px rgba(24, 95, 155, 0.3);
  }
}

.cxmc-section {
  margin-bottom: 20px;
  animation: fadeInUp 0.4s ease;
}

.cxmc-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  border: 1px solid rgba(24, 95, 155, 0.1);
}

/* 项目标题区域 */
.cxmc-header {
  display: flex;
  align-items: center;
  padding: 20px;
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
  color: #fff;
  gap: 16px;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: -50%;
    right: -10%;
    width: 200px;
    height: 200px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
  }

  &::after {
    content: "";
    position: absolute;
    bottom: -30%;
    left: -5%;
    width: 150px;
    height: 150px;
    background: rgba(255, 255, 255, 0.08);
    border-radius: 50%;
  }
}

.header-icon {
  font-size: 32px;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
  position: relative;
  z-index: 1;
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}

.header-content {
  flex: 1;
  position: relative;
  z-index: 1;
}

.project-title {
  margin: 0 0 6px 0;
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  line-height: 1.3;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.project-subtitle {
  margin: 0;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.4;
  display: flex;
  align-items: center;
  gap: 4px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.header-badge {
  position: relative;
  z-index: 1;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);

  .van-icon {
    font-size: 20px;
    color: #fff;
  }
}

/* 表格容器 */
.cxmc-table-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

/* 表格样式 */
.cxmc-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
}

.cxmc-table thead {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

.cxmc-table thead tr {
  border-bottom: 2px solid #185f9b;
}

.cxmc-table th {
  padding: 14px 12px;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  color: #333;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.th-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;

  .van-icon {
    font-size: 16px;
    color: #185f9b;
  }
}

.rank-col {
  width: 80px;
}

.team-col {
  min-width: 120px;
}

.player-col {
  min-width: 140px;
}

/* 表格行 */
.table-row {
  border-bottom: 1px solid #f0f0f0;
  transition: all 0.3s ease;
}

.table-row:hover {
  background: linear-gradient(135deg, #f8f9ff 0%, #e8f2ff 100%);
  transform: translateX(2px);
}

/* 高亮行 */
.highlight-row {
  background: linear-gradient(135deg, #fff3cd 0%, #ffe8a1 100%) !important;
  animation: highlightPulse 1.5s ease-in-out;
  box-shadow: 0 0 0 2px #ffc107;
}

@keyframes highlightPulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
}

.table-row:last-child {
  border-bottom: none;
}

/* 斑马纹 */
.even-row {
  background: #fafbfc;
}

.even-row:hover {
  background: linear-gradient(135deg, #f8f9ff 0%, #e8f2ff 100%);
}

/* 弃权行样式 */
.quit-row {
  background: rgba(255, 0, 0, 0.03);
  opacity: 0.7;
}

.quit-row:hover {
  background: rgba(255, 0, 0, 0.06);
}

/* 表格单元格 */
.cxmc-table td {
  padding: 14px 12px;
  text-align: center;
  font-size: 14px;
  color: #333;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* 名次徽章 */
.rank-cell {
  padding: 10px 12px;
}

.rank-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 50px;
  height: 40px;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 700;
  padding: 0 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.rank-icon {
  font-size: 20px;
  line-height: 1;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.2));
}

.rank-number {
  font-size: 16px;
  font-weight: 700;
  line-height: 1;
}

.rank-badge.rank-gold {
  background: linear-gradient(135deg, #ffd700 0%, #ffed4a 100%);
  color: #8b5a00;
  box-shadow: 0 4px 12px rgba(255, 215, 0, 0.4);
}

.rank-badge.rank-silver {
  background: linear-gradient(135deg, #c0c0c0 0%, #e8e8e8 100%);
  color: #666;
  box-shadow: 0 4px 12px rgba(192, 192, 192, 0.4);
}

.rank-badge.rank-bronze {
  background: linear-gradient(135deg, #cd7f32 0%, #e6a157 100%);
  color: #fff;
  box-shadow: 0 4px 12px rgba(205, 127, 50, 0.4);
}

.rank-badge.rank-normal {
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
  color: #fff;
}

.table-row:hover .rank-badge {
  transform: scale(1.05);
}

/* 队伍单元格 */
.team-cell {
  text-align: left;
  font-weight: 500;
  color: #333;
}

.team-info {
  .team-icon {
    font-size: 14px;
    color: #185f9b;
  }
}

/* 球员单元格 */
.player-cell {
  text-align: left;
}

.player-info {
}

.player-name {
  color: #333;
  font-weight: 500;
}

.player-divider {
  color: #999;
  margin: 0 2px;
}

.quit-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-left: 8px;
  padding: 3px 10px;
  background: linear-gradient(135deg, #ff4d4f 0%, #ff7875 100%);
  color: #fff;
  font-size: 12px;
  border-radius: 12px;
  font-weight: 600;
  box-shadow: 0 2px 6px rgba(255, 77, 79, 0.3);

  .van-icon {
    font-size: 12px;
  }
}

/* 底部统计信息 */
.cxmc-footer {
  padding: 16px 20px;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-top: 1px solid #e9ecef;
}

.footer-stats {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #666;

  .van-icon {
    font-size: 16px;
    color: #185f9b;
  }

  span {
    font-weight: 500;
  }
}

.stat-divider {
  width: 1px;
  height: 16px;
  background: #ddd;
}

/* ==================== 响应式设计 ==================== */
@media (max-width: 768px) {
  .filter-bar {
    padding: 10px 12px;
    gap: 10px;
  }

  .filter-item {
    padding: 8px 12px;
  }

  .filter-label {
    font-size: 12px;

    .van-icon {
      font-size: 14px;
    }
  }

  .filter-value {
    font-size: 13px;

    span {
      max-width: 60px;
    }
  }

  .filter-reset {
    width: 36px;
    height: 36px;

    .van-icon {
      font-size: 16px;
    }
  }

  .cxmc-header {
    padding: 16px;
    gap: 12px;
  }

  .header-icon {
    font-size: 28px;
  }

  .project-title {
    font-size: 16px;
  }

  .project-subtitle {
    font-size: 13px;
  }

  .cxmc-table th,
  .cxmc-table td {
    padding: 10px 8px;
    font-size: 13px;
  }

  .rank-badge {
    min-width: 46px;
    height: 36px;
    font-size: 14px;
    padding: 0 10px;
    gap: 4px;
  }

  .rank-icon {
    font-size: 18px;
  }

  .rank-number {
    font-size: 14px;
  }

  .rank-col {
    width: 70px;
  }
}

@media (max-width: 480px) {
  .filter-bar {
    padding: 8px 10px;
    gap: 8px;
  }

  .filter-item {
    padding: 8px 10px;
    border-radius: 10px;
  }

  .filter-label {
    font-size: 11px;
    gap: 4px;

    .van-icon {
      font-size: 13px;
    }
  }

  .filter-value {
    font-size: 12px;
    gap: 4px;

    span {
      max-width: 50px;
    }

    .van-icon {
      font-size: 12px;
    }
  }

  .filter-reset {
    width: 32px;
    height: 32px;

    .van-icon {
      font-size: 14px;
    }
  }

  .project-list {
    padding: 8px;
  }

  .project-card {
    padding: 12px;
    border-radius: 12px;
  }

  .card-icon .icon-wrapper {
    width: 42px;
    height: 42px;

    .van-icon {
      font-size: 20px;
    }
  }

  .project-name {
    font-size: 15px;
  }

  .project-info {
    font-size: 12px;

    .info-badge {
      font-size: 11px;
      padding: 2px 8px;
    }
  }

  .cxmc-container {
    padding: 0 8px 8px;
  }

  .cxmc-header {
    padding: 12px;
    gap: 10px;
  }

  .header-icon {
    font-size: 24px;
  }

  .project-title {
    font-size: 15px;
  }

  .project-subtitle {
    font-size: 12px;
  }

  .cxmc-table th,
  .cxmc-table td {
    padding: 8px 6px;
    font-size: 12px;
  }

  .rank-badge {
    min-width: 42px;
    height: 32px;
    font-size: 13px;
    padding: 0 8px;
    gap: 3px;
  }

  .rank-icon {
    font-size: 16px;
  }

  .rank-number {
    font-size: 13px;
  }

  .rank-col {
    width: 60px;
  }

  .quit-tag {
    font-size: 11px;
    padding: 1px 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ChangeXmIndex/ChangeXmIndex.vue